var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgUniverseExpansionFrame = function SvgUniverseExpansionFrame(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1095 1199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7231_38515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M703.144 501.457L670.602 697.24H381.826L414.347 501.457H703.144Z",
    stroke: "#2F486F",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.824 421.543L707.372 777.152H321.635L381.05 421.543H766.824Z",
    stroke: "#2F486F",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.265 334.973L735.828 863.727H251.417L340.799 334.973H825.265Z",
    stroke: "#2F486F",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.727 248.398L769.98 950.298H194.492L311.656 248.398H888.727Z",
    stroke: "#2F486F",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M953.94 161.828L809.083 1036.87H126.013L272.521 161.828H953.94Z",
    stroke: "#2F486F",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.14 75.2539L843.506 1123.44H64.0762L239.831 75.2539H1019.14Z",
    stroke: "#2F486F",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.64 2L891.892 1196.7H2.36386L202.989 2H1092.64Z",
    stroke: "#2F486F",
    strokeWidth: 4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7231_38515"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1095,
    height: 1199,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUniverseExpansionFrame);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTA5NSAxMTk5IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfNzIzMV8zODUxNSkiPgo8cGF0aCBkPSJNNzAzLjE0NCA1MDEuNDU3TDY3MC42MDIgNjk3LjI0SDM4MS44MjZMNDE0LjM0NyA1MDEuNDU3SDcwMy4xNDRaIiBzdHJva2U9IiMyRjQ4NkYiIHN0cm9rZS13aWR0aD0iNCIvPgo8cGF0aCBkPSJNNzY2LjgyNCA0MjEuNTQzTDcwNy4zNzIgNzc3LjE1MkgzMjEuNjM1TDM4MS4wNSA0MjEuNTQzSDc2Ni44MjRaIiBzdHJva2U9IiMyRjQ4NkYiIHN0cm9rZS13aWR0aD0iNCIvPgo8cGF0aCBkPSJNODI1LjI2NSAzMzQuOTczTDczNS44MjggODYzLjcyN0gyNTEuNDE3TDM0MC43OTkgMzM0Ljk3M0g4MjUuMjY1WiIgc3Ryb2tlPSIjMkY0ODZGIiBzdHJva2Utd2lkdGg9IjQiLz4KPHBhdGggZD0iTTg4OC43MjcgMjQ4LjM5OEw3NjkuOTggOTUwLjI5OEgxOTQuNDkyTDMxMS42NTYgMjQ4LjM5OEg4ODguNzI3WiIgc3Ryb2tlPSIjMkY0ODZGIiBzdHJva2Utd2lkdGg9IjQiLz4KPHBhdGggZD0iTTk1My45NCAxNjEuODI4TDgwOS4wODMgMTAzNi44N0gxMjYuMDEzTDI3Mi41MjEgMTYxLjgyOEg5NTMuOTRaIiBzdHJva2U9IiMyRjQ4NkYiIHN0cm9rZS13aWR0aD0iNCIvPgo8cGF0aCBkPSJNMTAxOS4xNCA3NS4yNTM5TDg0My41MDYgMTEyMy40NEg2NC4wNzYyTDIzOS44MzEgNzUuMjUzOUgxMDE5LjE0WiIgc3Ryb2tlPSIjMkY0ODZGIiBzdHJva2Utd2lkdGg9IjQiLz4KPHBhdGggZD0iTTEwOTIuNjQgMkw4OTEuODkyIDExOTYuN0gyLjM2Mzg2TDIwMi45ODkgMkgxMDkyLjY0WiIgc3Ryb2tlPSIjMkY0ODZGIiBzdHJva2Utd2lkdGg9IjQiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF83MjMxXzM4NTE1Ij4KPHJlY3Qgd2lkdGg9IjEwOTUiIGhlaWdodD0iMTE5OSIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";